export default "__VITE_ASSET__DCiP2RXJ__"